import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { EmptyObject } from 'type-fest'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { GET_ASTERIO_BID_TOKEN } from './api/query'
import { Data } from './api/types'
import { Token, UseGetAsterioBidToken } from './types'

export const useGetAsterioBidToken = (): UseGetAsterioBidToken => {
  const { t } = useTranslation('features/performance', { keyPrefix: 'prebidStack' })
  const { enqueueSnackbar } = useSnackbar()
  const [token, setToken] = useState<Token>()

  const { isLoading: loading } = useQuery<EmptyObject, Data>({
    onCompleted: async (data: Data) => {
      const { prebidManagerPublisherToken: token } = data

      if (!token) {
        enqueueSnackbar(t('asterioBid.error.connection'), { variant: 'error' })
      } else {
        setToken(token)
      }
    },
    query: GET_ASTERIO_BID_TOKEN,
  })

  return {
    loading,
    token,
  }
}
